import api from '../../../services/api';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function VeiculoItem() {
    const { id } = useParams();
    const [imageData, setImageData] = useState(null);
    const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
    const { register, handleSubmit, reset } = useForm();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            convertToBase64(file);
        }
    };

    const convertToBase64 = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            setImageData(reader.result);
        };
        reader.onerror = (error) => {
            console.error('Erro ao converter a imagem para Base64:', error);
        };
    };

    const onSubmit = async (data) => {
        if (!imageData) {
            console.error('Nenhuma imagem foi selecionada.');
            return;
        }

        const formData = {
            ...data,
            foto: imageData,
        };

        try {
            await api.put(`/veiculo/${id}`, formData);
            mostrarAlerta('Veículo atualizado com sucesso!', 'success');
            setTimeout(() => {
                window.location.href = '/veiculo';
            }, 1500);
        } catch (error) {
            mostrarAlerta('Erro ao atualizar o veículo!', 'error');
        }
        setTimeout(fecharAlerta, 3000);
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/veiculo/${id}`);
                reset(response.data);
                if (response.data.foto) {
                    setImageData(`data:image/jpeg;base64,${response.data.foto}`);
                }
            } catch (error) {
                console.error('Erro ao buscar o veículo:', error);
            }
        }

        fetchData();
    }, [id, reset]);

    return (
        <PageContainer sx={{ maxWidth: 700 }}>
            <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
                <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
                    Atualização de Veículo
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                    <Avatar src={imageData || undefined} variant="rounded" sx={{ width: 120, height: 90, bgcolor: 'primary.light' }}>
                        {!imageData && <DirectionsCarOutlinedIcon fontSize="large" />}
                    </Avatar>
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField {...register("tipo")} label="Tipo de veículo" placeholder="Ex.: Caminhão, Munck, Trator..." required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField {...register("marca")} label="Marca" placeholder="Ex.: Volvo, Iveco, Mercedes..." required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField {...register("placa")} label="Placa" placeholder="Ex.: OXO-3506, RLU4G96..." required fullWidth InputLabelProps={{ shrink: true }} />
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="outlined" component="label" fullWidth>
                            Selecionar nova foto
                            <input
                                {...register("foto")}
                                type="file"
                                accept="image/*"
                                hidden
                                onChange={handleFileChange}
                            />
                        </Button>
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
                        Atualizar
                    </Button>
                </Box>
            </Paper>

            <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
        </PageContainer>
    );
}

export default VeiculoItem;
